<template>
	<div>
		<el-dialog title="选择机台" :visible.sync="visible" :before-close="beforClose" width="800px">
			<el-table border ref="deviceTable" :data="devices" size="small" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55"> </el-table-column>
				<el-table-column type="index" label="序号" width="60"></el-table-column>
				<el-table-column label="所在车间" width="100">
					<template slot-scope="scope">
						<div v-text="getWorkshopName(scope.row.workshop_id)"></div>
					</template>
				</el-table-column>
				<el-table-column property="name" label="机台名称"></el-table-column>
				<el-table-column property="type" label="机台类型" width="100">
					<template slot-scope="scope">
						<span v-text="getDeviceTypeName(scope.row)"></span>
					</template>
				</el-table-column>
				<el-table-column property="code" label="机台编号" width="100"></el-table-column>
			</el-table>

			<span slot="footer" class="dialog-footer">
				<el-button @click="cancel">取 消</el-button>
				<el-button type="primary" @click="set">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import jtRequest, { jtInfoRequest } from '@/network/requests/jtInfo'
	import deviceType from './DeviceType'
	import { workshopRequest } from '@/network/requests/workshop'
	export default {
		name:"device",
		components: {},
		props: {
			show: {
				type: Boolean,
			},
			checkedValues: {
				type: Array,
			},
		},
		data() {
			return {
				devices: [],
				workshopId: 0,
				workshops: [],
				pageSize: 10,
				pageIndex: 1,
				pageCount: 0,
				visible: false,
				multipleSelection: [],
			}
		},
		watch: {
			show(val) {
				this.visible = val
				if (val && this.devices) {
					setTimeout(() => {
						//选中默认已有机台。
						this.selectDefaultRow(this.devices)
					}, 200)
				}
			},
		},
		methods: {
			/**
			 * 获取车间所有机台。
			 */
			query() {
				var filter = {}
				var p1
				if (this.workshopId) {
					filter['workshop_id'] = this.workshopId
					p1 = jtRequest.getDevices(filter)
				} else {
					p1 = jtRequest.getDevices()
				}

				var p2 = workshopRequest.queryAll()

				Promise.all([p1, p2])
					.then(result => {
						console.log('加载设备信息', result)
						this.devices = result[0]
						this.workshops = result[1]
					})
					.catch(err => {
						console.error(err)
					})
			},
			selectDefaultRow(devices) {
				console.log('checkedValues', this.checkedValues)
				var self = this
				this.checkedValues.forEach(p => {
					var row = devices.filter(t => t._id.$oid == p)[0]

					console.log('checked row', row, this.$refs.deviceTable)
					this.$refs.deviceTable.toggleRowSelection(row)
				})
			},
			/**
			 * 获取设备类型。
			 */
			getDeviceTypeName(row) {
				return deviceType.getName(row.type)
			},
			/**
			 * 获取车间名称。
			 */
			getWorkshopName(id) {
				var ws = this.workshops.find(t => t._id.$oid == id)
				if (ws) {
					return ws.name
				}

				return ''
			},
			/**
			 * 设置设备。
			 */
			set() {
				var selectedDevices = []
				this.multipleSelection.forEach((v, i) => {
					console.log(v)

					selectedDevices.push({
						id: v._id.$oid,
						name: v.name,
					})
				})

				var selectRow = this.$emit('setDevice', selectedDevices)
				this.$emit('close')
			},
			/**
			 * 关闭
			 */
			beforClose(done) {
				this.$emit('close')
				done()
			},
			detailDialogClose() {
				this.showDetail = false
			},
			handleSelectionChange(val) {
				this.multipleSelection = val
				console.log("val: "+val.length)
			},
			cancel() {
				this.commit()			 
				this.visible = false
				this.$emit('close')
			},
			commit(){
					this.$refs.deviceTable.clearSelection()
			}
		},
		created() {
			this.query()
		},
	}
</script>

<style></style>
